Vendd.Scripts.load(function () {

    var $wrapper = $('.x-dynamic-discount-banners');

    if ($wrapper.length < 1) return;

    var model = null, html, discounts = [], popUpIsOpen = false;
    var cookieDuration = $wrapper.data('cookie-duration') || 1; //duration in days

    $wrapper.remove();

    function initDynamicDiscountBanners() {
        //get an array with discount ids
        getDiscounts();

        var cookie = Cookies.get('dynamicDiscountCookie');

        if (!cookie || typeof cookie === "undefined") {
            //init pop up
            initPopUp(cookie);

        } else {
            //get discount ids from cookie
            var displayedDiscounts = JSON.parse(Cookies.get("dynamicDiscountCookie"));
            //check if there is difference
            var featuredDiscounts = difference(discounts, displayedDiscounts);

            if (featuredDiscounts.length < 1) return; 

            //get featured discounts from model
            var filteredItems = model.Items.filter(function (item) {
                if (contains(featuredDiscounts, item.Discount.Id))
                    return item;
            });

            //change model
            model.Items = filteredItems;
            //init poop up
            initPopUp(cookie);
        }
        
    };

    function initPopUp(cookie) {

        if (popUpIsOpen) return;

        html = Vendd.Handlebars.parse("dynamicDiscountBanners_A", model);

        $.fancybox.open(html, {
            type: 'iframe',
            touch: false,
            fitToView: false,
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
            padding: 0,
            beforeShow: function () {
                if (cookie) Cookies.remove('dynamicDiscountCookie');
                popUpIsOpen = true;
            },
            afterShow: function () {
                bindEvents();
            },
            afterClose: function () {
                Cookies.set("dynamicDiscountCookie", discounts, { expires: cookieDuration, samesite: 'Lax' });
                popUpIsOpen = false;
            }
        });
    }

    function bindEvents() {
        var $popUp = $('.x-discount-dynamic-banners');

        //Get <a> link inside popup
        var $link = $('.js-update-cookie-first', $popUp);
        if ($link.length < 1) return;
        var redirectURL = $link.attr('href');

        //Bind event: First update cookie and then redirect
        $link.on('click', function (evt) {
            evt.preventDefault();
            Cookies.set("dynamicDiscountCookie", discounts, { expires: cookieDuration, samesite: 'Lax' });            
            window.location = redirectURL;
        })
    }
    

    //get an array with discount ids
    function getDiscounts() {
        model.Items.forEach(function (item) {
            discounts.push(item.Discount.Id);
        });

        return discounts;      
    };

    //when there is a change in cart
    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, "DynamicDiscountBanners", function (envelope) {
        var data = envelope.message.data;
        var noDiscountCookie = Cookies.get('noDynamicDiscountCookie');
        var popupCookie = Cookies.get('dynamicDiscountCookie');

        //if cart model has not changed
        if (data.IsLocalStorageCache && (noDiscountCookie || popupCookie)) {
            return;
        } else {
            //remove cookie
            if (noDiscountCookie) Cookies.remove('noDynamicDiscountCookie');

            //call service for PromotedDiscounts
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetPromotedDiscounts());
        }     
    });

    //on success of GetPromotedDiscounts
    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GetPromotedDiscountsSuccess, "DynamicDiscountBanners", function (envelope) {
        model = envelope.message.data.Data;

        if (model.ItemsCount > 0) {
            //init Dynamic Discount Banners
            initDynamicDiscountBanners();
        } else {
            //set cookie for empty array of dynamic discounts
            Cookies.set("noDynamicDiscountCookie", { expires: cookieDuration, samesite: 'Lax' });

            return;
        }
    });

});